// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@conklin/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.attributeWrapper = {
    css: css`
        margin-top: 40px;
        width: 100%;
        max-width: 100%;
        padding-top: 20px;
        border-top: 1px solid ${color("common.border", 0.5)};
    `,
};

carouselStyles.attributeContainer = {
    css: css`
        width: 100%;
        max-width: 100%;
        border-radius: 4px;
        background-color: ${color("common.white")};
    `,
};

carouselStyles.attributeLabel = {
    as: "p",
    size: 12,
    weight: fontConfig.weight.bold,
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        padding: 10px 10px 10px 0px;
        background: ${color("common.white")};
        min-height: 36px;
        &.first-item {
            border-radius: 4px 4px 0 0;
        }
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        text-align: center;
        min-height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 0;
    `,
};

carouselStyles.attributesCarouselExtendedStyles = {
    container: {
        css: css`
            background: ${color("common.ui2")};
        `,
    },
};

carouselStyles.carouselCellGridItem = {
    width: 8,
    css: css`
        &&&& {
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 auto;
            .swiper-slide {
                // to make all slider same height
                height: auto;
                // To fix swiper render issue
                margin-top: 1px;
                margin-bottom: 1px;
            }
        }
    `,
};
